// Vue
import { Vue, Component, Prop, Inject } from "vue-property-decorator";

// Template
import template from "./template.vue";

// Base Module
import ModuleBase from "#/common/ModuleBase";
import { ViewModel } from "./ViewModel";

// Components
import ModuleWrapper from "#/components/module_wrapper/ModuleWrapper";
import { Sticky } from "../../../components/sticky/Sticky";
import { Observer } from "mobx-vue";
import { Api } from "../../../api";
import { addTokenParameterIfInCurrentUrl } from "../../../common/Utils";

@Observer
@Component({
  mixins: [template],
  components: {
    ModuleWrapper,
    Sticky,
  },
})
export class BreadcrumbKatalogModule extends ModuleBase {
  public viewModel!: ViewModel;

  private crumbs: object[] = [];

  private home: object = {};

  created() {
    this.loadCrumbs();
  }

  public getBackgroundColorFromInstance(instance: object) {
    return instance["background"];
  }

  get breadcrumbTheme() {
    return this.backgroundColor == "white" ? "default" : "secondary";
  }

  get isSticky() {
    return this.instance["is_sticky"];
  }

  get hasTopLink() {
    return this.instance["has_top_link"];
  }

  private async loadCrumbs() {
    let token = this.$store.typeSelectionFilter.getToken();
    if (token) {
      let crumbs = await Api.pageService.getKatalogBreadcrumb(
        this.$store.page.page!.id,
        token
      );

      let crumbsWithoutHome = crumbs.slice(1);

      if (crumbs.length > 0) {
        this.home = {
          href: crumbs[0].link,
          active: crumbs.length == 1,
        };
      }

      this.crumbs = crumbsWithoutHome.map((b, index) => {
        let result = {
          title: b.title,
          name: addTokenParameterIfInCurrentUrl(b.link),
          active: crumbsWithoutHome.length - 1 == index,
        };

        if (b.alternatives) {
          result["alternatives"] = b.alternatives
            .filter((a) => a.title && a.link)
            .map((a) => {
              return {
                title: a.title,
                name: addTokenParameterIfInCurrentUrl(a.link),
              };
            })
            .sort((a, b) => {
              return a.title.localeCompare(b.title);
            });
        }

        return result;
      });
    } else {
      this.home = this.$store.page.breadcrumbHome;
      this.crumbs = this.$store.page.breadcrumbs;
    }
  }
}
